<div class="container-fluid">
    <div class="row" *ngIf="messageMax">
        <div class="col">
            <p class="text-center">{{ messageMax }}</p>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col" *ngIf="imageChangedEvent">
            <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [resizeToWidth]="250" [aspectRatio]="4 / 3" format="png" (imageCropped)="imageCropped($event)"></image-cropper>
        </div>
        <div class="col" *ngIf="!imageChangedEvent">
            <p class="text-muted text-center">Selecciona una imagen para editar</p>
        </div>
        <div class="col" *ngIf="realSize">
            <h3>Vista previa</h3>
            <img [src]="croppedImage" />
        </div>
    </div>
    <div class="row" *ngIf="realSize">
        <div class="col">
            <p>Tamaño final de la imagen: {{ realSize }} KB {{ bytesToMB }} MB</p>
        </div>
    </div>
    <div class="row">
        <div class="col d-flex justify-content-center gap-3">
            <div class="file-input-wrapper">
                <button type="button" class="btn btn-primary" (click)="triggerFileInput()">Cargar</button>
                <input type="file" #fileInput (change)="fileChangeEvent($event)" accept="image/*" style="display: none" />
            </div>
            <button type="button" class="btn btn-primary" (click)="onNoClick()">Cancelar</button>
            <button type="button" class="btn btn-primary" (click)="onSaveClick()" [disabled]="errorSize">Guardar</button>
        </div>
    </div>
</div>